import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const GeomapWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function GeomapWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path
        d="M16.4275 27.7965C16.7819 27.3662 25 17.2732 25 12.3023C25 9.83518 24.0518 7.4691 22.364 5.72458C20.6761 3.98006 18.3869 3 16 3C13.6131 3 11.3239 3.98006 9.63604 5.72458C7.94821 7.4691 7 9.83518 7 12.3023C7 17.2732 15.2181 27.3662 15.5725 27.7965C15.6253 27.8603 15.6909 27.9115 15.7647 27.9467C15.8385 27.9818 15.9187 28 16 28C16.0813 28 16.1615 27.9818 16.2353 27.9467C16.3091 27.9115 16.3747 27.8603 16.4275 27.7965ZM12.0625 12.3023C12.0625 11.4974 12.2934 10.7105 12.7261 10.0413C13.1587 9.372 13.7737 8.85037 14.4932 8.54234C15.2127 8.23431 16.0044 8.15372 16.7682 8.31075C17.532 8.46778 18.2336 8.85539 18.7842 9.42455C19.3349 9.99372 19.7099 10.7189 19.8618 11.5083C20.0138 12.2978 19.9358 13.1161 19.6378 13.8597C19.3398 14.6034 18.8351 15.239 18.1876 15.6862C17.54 16.1334 16.7788 16.3721 16 16.3721C14.9557 16.3721 13.9542 15.9433 13.2158 15.1801C12.4773 14.4168 12.0625 13.3817 12.0625 12.3023Z"
        fill="#6C4FC2"
      />
    </SvgStyled>
  );
});
